import { ROLES } from '@/constants/roles';

const routes = [
  {
    path: '/event/categories',
    name: 'event-categories',
    component: () => import('./views/CategoriesList.vue'),
    meta: {
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/event-categories/view/:id',
    name: 'event-categories-view-id',
    component: () => import('./views/PublicCategory/index.vue'),
    meta: {
      title: 'Категория мероприятия',
      layout: 'empty',
    },
  },
  {
    path: '/event/categories/create',
    name: 'event-categories-create',
    component: () => import('./views/CreateCategory.vue'),
    meta: {
      accessList: [ROLES.organization],
      title: 'Создание категории',
    },
  },
  {
    path: '/event/categories/edit/:id',
    name: 'event-categories-edit-id',
    component: () => import('./views/UpdateCategory.vue'),
    meta: {
      accessList: [ROLES.organization],
      title: 'Редактирование категории',
    },
  },
  {
    path: '/event/categories/edit/:id/events',
    name: 'event-categories-edit-id-events',
    component: () => import('./views/EditEvents/index.vue'),
    meta: {
      accessList: [ROLES.organization],
      title: 'Редактирование списка мероприятий',
    },
  },
];
export default routes;
